import React from 'react';
import styles from './HeadingText.module.scss';

interface HeadingProps {
  text: string;
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  className?: string;
  align?: 'left' | 'center' | 'right';
  color?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
}

const HeadingText: React.FC<HeadingProps> = ({ text, level = 1, className = '', align = 'center', color, size }) => {
  const getSizeClass = () => {
    switch (size) {
      case 'sm':
        return styles.small;
      case 'md':
        return styles.medium;
      case 'lg':
        return styles.large;
      case 'xl':
        return styles.xlarge;
      case 'xxl':
        return styles.xxlarge;
      default:
        return '';
    }
  };

  const getAlignClass = () => {
    switch (align) {
      case 'left':
        return styles.left;
      case 'center':
        return styles.center;
      case 'right':
        return styles.right;
      default:
        return styles.center;
    }
  };

  const combinedClassName = `
    ${styles.heading} 
    ${getSizeClass()} 
    ${getAlignClass()} 
    ${className}
  `.trim();

  const style = color ? { color } : {};

  const headingProps = {
    className: combinedClassName,
    style,
    children: text,
  };

  switch (level) {
    case 1:
      return <h1 {...headingProps} />;
    case 2:
      return <h2 {...headingProps} />;
    case 3:
      return <h3 {...headingProps} />;
    case 4:
      return <h4 {...headingProps} />;
    case 5:
      return <h5 {...headingProps} />;
    case 6:
      return <h6 {...headingProps} />;
    default:
      return <h1 {...headingProps} />;
  }
};

export default HeadingText;
